












































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import { ModelSync, Prop } from 'vue-property-decorator'
import Fuse from 'fuse.js'
import { PermissionCollectionModel } from '@/modules/permission/models/permission-collection.model'

@Component({
  components: {
    Checkbox,
    BaseInput
  }
})
export default class AdminPermissionFuzzySearch extends Vue {
  @ModelSync('value', 'input', { required: true })
  selectedPermissions: PermissionCollectionModel['id'][]

  @Prop({ required: true }) permissions: PermissionCollectionModel[]
  @Prop({ default: 'جستجو مجوز' }) placeholder: string
  @Prop({ default: 500 }) debounce: string | number
  @Prop({ default: 300 }) scrollAreaHeight: string | number

  private search: string = ''

  private get __debounce() {
    const parsedDebounce = parseInt(this.debounce.toString(), 10)
    return Number.isNaN(parsedDebounce) || parsedDebounce < 0 ? 500 : parsedDebounce
  }

  private get permissionsFuse() {
    return new Fuse(this.permissions, { keys: ['name'] })
  }

  private get filteredPermissions() {
    return this.search
      ? this.permissionsFuse.search(this.search).map(fuse => fuse.item)
      : this.permissions
  }

  private get scrollAreaStyle() {
    return {
      height: typeof this.scrollAreaHeight === 'string' ? this.scrollAreaHeight : `${this.scrollAreaHeight}px`
    }
  }
}
